import { useQuery } from '@tanstack/react-query';

import { kubesoloTestHostOutput } from '@api/sdk.gen';
import { KubesoloHostResult, KubesoloTest } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

/** Keyed on the output's tail, so it refetches with the test's polling only while the machine prints more. */
export function useHostOutput(
  testId: KubesoloTest['id'],
  host: KubesoloHostResult,
  { enabled }: { enabled: boolean }
) {
  return useQuery({
    queryKey: [...queryKeys.output(testId, host.id), host.outputTail],
    queryFn: () => getHostOutput(testId, host.id),
    keepPreviousData: true,
    // each tail is a new entry holding the full output, so drop the old ones at once
    cacheTime: 0,
    enabled,
    ...withError("Unable to load the machine's output"),
  });
}

async function getHostOutput(
  testId: KubesoloTest['id'],
  hostId: KubesoloHostResult['id']
) {
  const { data } = await kubesoloTestHostOutput({
    path: { id: testId, hostID: hostId },
  });
  return data.output;
}
